export default "__VITE_ASSET__MTOGJP4X__"